import useBootstrapData from '@/hooks/useBootstrapData'
import useSeti from '@/hooks/useSeti'
import pclnExperimentation from '@pcln/experimentation'

export default function useTravelChatBot() {
  const { locale } = useBootstrapData()

  const isUS = locale?.countryCode?.toLowerCase() === 'us'
  const isPennyOutsideUS = useSeti('PENNY_WORLWIDE', false) === 'VARIANT'

  if (!isUS) {
    pclnExperimentation.fireImpression('PENNY_WORLWIDE')
  }

  return isUS || isPennyOutsideUS
}
